import React from 'react'
import emptyImg from '../../images/list-empty.png'
import { WKVisible } from '../../components/wk'


export default function (props) {
    return (
        <div className="list-empty text-center">
            <div>
                <img src={emptyImg} alt=""/>
                <div className="text">
                    <WKVisible create={props.type === 'lecture'}>
                        <p>创建课程，开启你的知识付费时代</p>
                    </WKVisible>
                    <WKVisible create={props.type === 'channel'}>
                        <p>一个专栏可包含多节课程</p>
                    </WKVisible>
                    <p>点击下方按钮立即创建</p>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/ListEmpty.js